import {
  getEventAnnouncementCardClass,
  getEventAnnouncementToneClass,
  resolveEventAnnouncementTitle,
  resolveEventTimetableRuntimeTitle,
  renderEventAnnouncementCard,
  renderEventTimetableRuntimeCard,
  withEventAnnouncementScopeTitle,
} from '../timeline/eventSystemMessageUtils';

export function createEventAnnouncementRenderers({
  selectedEventInfo,
  selectedEventId,
  resolveEventChatMode,
  unifiedMode,
  announcementChecks,
  getAnnouncementIconClass,
  linkifyText,
  parseTimetableRuntimePayload,
  isTimetableMemoMessage,
  resolveTimetableRuntimeVisibility,
  buildTimetableDetailUrl,
}) {
  const withAnnouncementScopeTitle = (title, message) => {
    const selectedGroupMode = resolveEventChatMode(selectedEventInfo || {});
    return withEventAnnouncementScopeTitle({
      title,
      message,
      isGroupUnified: selectedGroupMode === unifiedMode,
    });
  };

  const resolveAnnouncementTitleByMessage = (message) =>
    resolveEventAnnouncementTitle(message, announcementChecks);

  const resolveTimetableRuntimeTitleByMessage = (message) =>
    resolveEventTimetableRuntimeTitle(message, announcementChecks);

  const getAnnouncementCardClassByMessage = (message) =>
    getEventAnnouncementCardClass(message, announcementChecks);

  const getAnnouncementToneClassByMessage = (message) =>
    getEventAnnouncementToneClass(message, announcementChecks);

  const renderAnnouncementCard = (message, extra, options = {}) => {
    return renderEventAnnouncementCard({
      message,
      extra,
      options,
      resolveAnnouncementTitle: resolveAnnouncementTitleByMessage,
      withAnnouncementScopeTitle,
      getAnnouncementCardClass: getAnnouncementCardClassByMessage,
      getAnnouncementIconClass,
      linkifyText,
    });
  };

  const renderTimetableRuntimeCard = (message) => {
    return renderEventTimetableRuntimeCard({
      message,
      parseTimetableRuntimePayload,
      isTimetableMemoMessage,
      resolveTimetableRuntimeVisibility,
      selectedEventId,
      resolveTimetableRuntimeTitle: resolveTimetableRuntimeTitleByMessage,
      withAnnouncementScopeTitle,
      getAnnouncementIconClass,
      linkifyText,
      buildDetailUrl: ({ selectedEventId: eventId, timetableId }) =>
        buildTimetableDetailUrl({ selectedEventId: eventId, timetableId }),
    });
  };

  return {
    withAnnouncementScopeTitle,
    getAnnouncementToneClass: getAnnouncementToneClassByMessage,
    renderAnnouncementCard,
    renderTimetableRuntimeCard,
  };
}
